import type { WorkSpaceType } from '../../Types/Api/WorkSpace'
import { api } from './API'
import { requireAuth } from './Auth'

export const findWorkspace = async () => {
  const res = await requireAuth<WorkSpaceType>(api.get(`workspaces`))

  // APIエンドポイントに無効なトークンを送信すると404をレスポンスするため
  if (res.status === 500 || res.status === 404) {
    localStorage.clear()
    location.reload()
  }

  return res
}
